export default "__VITE_ASSET__4Px8WUy4__"